module.exports = __webpack_public_path__ + "static/media/fileTXT.cdc57e93.svg";